export class DisplayGroupModel {
    name: string;
    order: number;
    description: string;
}
